import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { addSubscriber } from '../lib/mailchimp';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addSubscriber(email);
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
    } catch (error: any) {
      // Handle errors from our backend API
      if (typeof error.message === 'string') {
        if (error.message.includes('Member Exists')) {
          toast.error('You are already subscribed to our newsletter');
        } else if (error.message.includes('Invalid Resource') || error.message.includes('valid email')) {
          toast.error('Please enter a valid email address');
        } else {
          toast.error(error.message || 'Failed to subscribe. Please try again later.');
        }
      } else {
        toast.error('Failed to subscribe. Please try again later.');
      }
      console.error('Newsletter subscription error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col md:flex-row">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        className="px-4 py-3 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-[#73BDF2] focus:border-[#73BDF2] transition-colors duration-300 mb-4 md:mb-0 md:mr-4 flex-grow"
        required
      />
      <button 
        type="submit"
        disabled={loading}
        className="btn-primary disabled:opacity-50"
      >
        {loading ? 'Subscribing...' : 'Subscribe'}
      </button>
    </form>
  );
}